// @flow
import client from '../../client'

// API Endpoints
export const USER_SET_PASSWORD = '/auth/users/set-password/'

/**
 * Sets user's password
 * @param {Object} data User's password information
 * @param {string} data.password User's new password
 * @param {string} data.password_confirm User's new password confirmation
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const setPassword = (data: {
  password: string,
  password_confirm: string,
}): Promise<any> =>
  client.post(USER_SET_PASSWORD, { body: data }).then(() => true)

export default setPassword
